/* src/app/reports/grafana-report-orders/grafana-report-orders.component.css */
:host {
  display: block;
}
/*# sourceMappingURL=grafana-report-orders.component.css.map */
